import React from 'react';

import { Grid, Paper } from '@mui/material';
import Dropdown from '../../../../components/inputs/dropdown';
import Input from "../../../../components/inputs/input";
import useStyles from '../styles';

// Models
import { IibbCategoriesList } from '../../../../models/IibbCategories';

const values = [
    { label: 'NINGUNA', value: -1 },
    ...IibbCategoriesList
];

const Iibb = ({ iibb, handleChange }) => {
    const { classes } = useStyles();
    const handleInputChange = (event) =>
        handleChange({
            ...iibb,
            [event.target.name]: event.target.value
        })

    const handleInputChangeNumber = (event) => 
        handleChange({
            ...iibb,
            [event.target.name]: Number(event.target.value)
        });

    return (
        <Paper className={classes.paper} variant="outlined">
            <Grid container spacing={2}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}
                >
                    <Input
                        fullWidth
                        type='number'
                        label='Número ingresos brutos'
                        name='iibb'
                        onChange={handleInputChangeNumber}
                        value={ iibb.iibb || '' }
                        className={classes.input}
                        error={iibb?.iibb <= 0}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}
                >
                    <Dropdown
                        fullWidth
                        label='Categoría impositiva'
                        name='category'
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        values={values}
                        onChange={handleInputChange}
                        value={iibb?.category || -1}
                        className={classes.input}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
}

export default Iibb;